import React, { useState } from "react";
import { formatDate, formatDateNew, formatDateNewWithTime, formatDateWithTime } from "../../constants/DateUtil/DateUtil";
import CollectPaymentEdit from "./CollectPaymentEdit";
import { useNavigate } from "react-router-dom";

const PaymentInfoCard = ({
  orderPaymentDetailsData,
  storeCustomerId,
  storeId,
  bookingOrderId,
  sendDataToOrderGarmentInfo,
  balanceAmount,
  customerOrdersData,
  enableUserAccountDeliveryDiscount,
  storeUserId,
  userRole,
  enabledBackDate,
  enabledEditPayment,
  brandId,
  enabledAmountRoundOff
}) => {
  const navigate = useNavigate();
  const [collectPaymentEditModalVisible, setCollectPaymentEditModalVisible] =
    useState(false);
  const [selectedPaymentItemValue, setSelectedPaymentItemValue] =
    useState(null);

  const receiveDataFromCollectPaymentUpdateModal = ({ success }) => {
    if (success) {
      sendDataToOrderGarmentInfo({
        info: true,
      });
    }
  };

  const [show, setShow] = useState(false);

  const handleShowHide = () => {
    setShow(!show);
  };

  const renderOrderInfoItem = () => {
    return orderPaymentDetailsData?.map((item, index) => (
      <div className="flex-1 mx-3 my-2 pb-3">
        <div
          className="shadow-3 mt-4 border-1"
          style={{ borderColor: item.processed ? "#59f444" : item.processed === false ? "#f44444" : "#44bff4" }}
        >
          <div className="flex">
            <div className="flex flex-1 flex-column">
              <div className="mx-3 mt-2">
                <p className="text-md font-normal capitalize">Payment Mode :</p>
                <div className="flex flex-row justify-content-between align-items-center">
                  <p className="text-xl font-medium capitalize">
                    {item.paymentMode.replace(/_/g, " ")}
                  </p>
                  {item.processed ? <div
                    className="cursor-pointer"
                  >
                    <img
                      src={
                        "images/checked.png"
                      }
                      style={{
                        width: 30,
                        height: 30,
                      }}
                    />
                  </div> :
                    <div
                      className="cursor-pointer"
                    >
                      <img
                        src={
                          "images/Cross.jpeg"
                        }
                        style={{
                          width: 30,
                          height: 30,
                        }}
                      />
                    </div>}
                </div>
              </div>
              <div className="mx-3 my-1">
                <p className="text-md font-normal capitalize">Date :</p>
                <p className="text-xl font-medium capitalize">
                  {formatDateNewWithTime(item.date)}
                </p>
              </div>
              <div className="mx-3 mb-2">
                <p className="text-md font-normal capitalize">
                  Payment Received By:
                </p>
                <p className="text-xl font-medium capitalize">
                  {item.receiver.firstName + " " + item.receiver.lastName}
                </p>
              </div>
              {
                !item.processed && <div className="mx-3 mb-2">
                  <p className="text-md font-normal capitalize" style={{ color: "red" }}>
                    Transaction was failed
                  </p>
                </div>}
            </div>
            <div className="flex flex-1 flex-column">
              <div className="mx-3 mt-2">
                <p className="text-md font-normal capitalize">Amount :</p>
                <div className="flex flex-row justify-content-between align-items-center">
                  <p className="text-xl font-medium capitalize">
                    {Number(item.amount?.toFixed(enabledAmountRoundOff))}
                  </p>

                  {userRole === "BY_STORE" && item.processed &&
                    balanceAmount >= 0 &&
                    !["ONLINE", "ICICI_PG"].includes(
                      item.paymentMode) ? (
                    <div>
                      {enabledEditPayment && (
                        <div
                          className="cursor-pointer"
                          onClick={() => {
                            setSelectedPaymentItemValue(item);
                            setCollectPaymentEditModalVisible(true);
                          }}
                        >
                          <i
                            className="pi pi-pencil"
                            style={{
                              fontSize: "25px",
                              color: "#2B70D7",
                            }}
                          ></i>
                        </div>
                      )}
                    </div>
                  ) : (
                    userRole ===
                    "BY_ADMIN" && item.processed && (
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          setSelectedPaymentItemValue(item);
                          setCollectPaymentEditModalVisible(true);
                        }}
                      >
                        <i
                          className="pi pi-pencil"
                          style={{
                            fontSize: "25px",
                            color: "#2B70D7",
                          }}
                        ></i>
                      </div>
                    )
                  )}
                  {(userRole === "BY_STORE" || userRole === "BY_ADMIN") && (
                    <div
                      className="cursor-pointer"
                      onClick={() => {
                        navigate("/PaymentCollectionReceipt", {
                          state: {
                            storeId: storeId,
                            storeCustomerId: storeCustomerId,
                            bookingOrderId: bookingOrderId,
                            customerOrdersData: customerOrdersData,
                            paymentDetails: item,
                          },
                        });
                      }}
                    >
                      <img
                        src={
                          "Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png"
                        }
                        style={{
                          width: 30,
                          height: 30,
                        }}
                      />
                    </div>
                  )}

                </div>
              </div>
              <div className="mx-3 my-1">
                <p className="text-md font-normal capitalize">
                  Payment Reference No:
                </p>
                <p className="text-xl font-medium capitalize">
                  {item.paymentRefNo ? item.paymentRefNo : "N/A"}
                </p>
              </div>
              <div className="mx-3 mb-2">
                <p className="text-md font-normal capitalize">Role:</p>
                <p className="text-xl font-medium capitalize">
                  {item.receiver.role.replace(/ROLE_/g, "")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    ));
  };
  return (
    <div>
      <div
        className="shadow-2 mx-4 mt-2 mb-4 border-round-lg border-2 cursor-pointer"
        style={{ borderColor: "#44bff4" }}
      >
        <div
          onClick={handleShowHide}
          className="px-3 pb-1 flex flex-row justify-content-between align-items-center"
          style={{
            backgroundColor: "#44bff4",
          }}
        >
          <p className="text-white text-3xl font-bold capitalize">
            Payment Info
          </p>

          <i
            className={!show ? "pi pi-angle-down" : "pi pi-angle-up"}
            style={{
              fontSize: "25px",
              cursor: "pointer",
              color: "#fff",
            }}
          ></i>
        </div>

        {show && renderOrderInfoItem()}
      </div>
      <CollectPaymentEdit
        setCollectPaymentEditModalVisible={setCollectPaymentEditModalVisible}
        collectPaymentEditModalVisible={collectPaymentEditModalVisible}
        sendDataToCollectPaymentUpdateModal={
          receiveDataFromCollectPaymentUpdateModal
        }
        storeId={storeId}
        storeCustomerId={storeCustomerId}
        selectedPaymentItemValue={selectedPaymentItemValue}
        bookingOrderId={bookingOrderId}
        balanceAmount={balanceAmount}
        customerOrdersData={customerOrdersData}
        enableUserAccountDeliveryDiscount={enableUserAccountDeliveryDiscount}
        storeUserId={storeUserId}
        userRole={userRole}
        enabledBackDate={enabledBackDate}
        brandId={brandId}
        enabledAmountRoundOff={enabledAmountRoundOff}
      />
    </div>
  );
};

export default PaymentInfoCard;
